import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

const ObjectFilter = ({ allowClear }) => {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [selectedObjectId, setSelectedObjectId] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const objects = useQuery({
    queryKey: 'objectsSelect',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/objects2');
      return response.data.data;
    },
    enabled: !hasError,
    onSuccess: (data) => {
      if (data && data.length > 0) {
        let entries = Object.fromEntries(searchParams);
        if (Object.keys(entries).includes('objectId')) {
          setSelectedObjectId(searchParams.get('objectId'));
        }
      }
    },
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleChangeObject = (event) => {
    const {
      target: { value },
    } = event;
    searchParams.set('objectId', value);
    setSelectedObjectId(value);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    const { data } = objects;
    if (data && data?.length > 0) {
      let entries = Object.fromEntries(searchParams);
      if (Object.keys(entries).includes('objectId')) {
        setSelectedObjectId(searchParams.get('objectId'));
      } else {
        setSelectedObjectId('');
      }
    }
  }, [objects, searchParams]);

  const handleClearSelectBox = () => {
    searchParams.delete('objectId');
    setSelectedObjectId('');
    setSearchParams(searchParams);
  };

  return (
    <FormControl className='!border-none !m-0' fullWidth color='formColor'>
      <InputLabel id='objectId-label'>
        {t('common.fields.objectName')}
      </InputLabel>
      <Select
        labelId='objectId-label'
        id='objectId-select'
        label={t('common.fields.objectName')}
        onChange={handleChangeObject}
        value={selectedObjectId}
        color='formColor'
        variant='outlined'
        role='presentation'
        MenuProps={{ id: 'objectId-select-menu' }}
        size='small'
        endAdornment={
          <InputAdornment position='end' className='custom-endAdornment'>
            {allowClear && selectedObjectId && (
              <IconButton
                onClick={() => handleClearSelectBox()}
                variant='onlyIcon'
                className='select-box-end-adornment-button'
              >
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            )}
          </InputAdornment>
        }
      >
        {objects.isLoading || objects.isFetching ? (
          <div className='circular-progress-box'>
            <CircularProgress size={25} />
          </div>
        ) : objects.data && objects.data.length > 0 ? (
          objects.data.map((item, index) => (
            <MenuItem value={item.id} key={index + 1} className='small-size'>
              {item.name}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' />{' '}
              {t('common.global.noDataFound')}
            </span>
          </div>
        )}
      </Select>
    </FormControl>
  );
};
export default memo(ObjectFilter);
